import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { FormControl, MenuItem, Select } from "@mui/material";
var UISelect = function (_a) {
    var _b;
    var value = _a.value, defaultValue = _a.defaultValue, optionsSelect = _a.optionsSelect, onChange = _a.onChange, _c = _a.fullWidth, fullWidth = _c === void 0 ? true : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var _e = useState(defaultValue), innerValue = _e[0], setInnerValue = _e[1];
    var currentValue = (_b = innerValue !== null && innerValue !== void 0 ? innerValue : value) !== null && _b !== void 0 ? _b : optionsSelect[0].value;
    var handleChange = function (e) {
        var value = e.target.value;
        setInnerValue(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    return (_jsx(FormControl, { size: "small", fullWidth: fullWidth, disabled: disabled, children: _jsx(Select, { value: currentValue, onChange: handleChange, IconComponent: KeyboardArrowDownIcon, MenuProps: {
                PaperProps: {
                    sx: {
                        mt: 0.75,
                        borderRadius: 1.5,
                        bgcolor: "rgba(20,20,20,0.98)",
                        border: "1px solid var(--accent-border)",
                        boxShadow: "0 12px 30px rgba(0,0,0,0.55)",
                        color: "rgba(255,255,255,0.92)",
                    },
                },
                MenuListProps: {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5,
                        p: 0.75,
                    },
                },
            }, sx: {
                height: 32,
                fontFamily: "var(--default-font)",
                fontSize: 13,
                color: "rgba(255,255,255,0.92)",
                borderRadius: 1.5,
                bgcolor: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.12)",
                "& .MuiSelect-select": {
                    py: 0,
                    display: "flex",
                    alignItems: "center",
                },
                "& .MuiSvgIcon-root": {
                    color: "rgba(255,255,255,0.75)",
                    transition: "color 150ms ease",
                },
                "&:hover": {
                    bgcolor: "rgba(255,255,255,0.06)",
                    borderColor: "var(--accent-border)",
                    "& .MuiSvgIcon-root": {
                        color: "var(--accent-border)",
                    },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "0",
                },
            }, children: optionsSelect.map(function (el) { return (_jsx(MenuItem, { value: el.value, sx: {
                    fontFamily: "var(--default-font)",
                    fontSize: 13,
                    borderRadius: 1,
                    px: 1.5,
                    py: 0.75,
                    "&.Mui-selected": {
                        bgcolor: "rgba(255, 184, 1, 0.18)",
                    },
                    color: "rgba(255,255,255,0.92)",
                    "&:hover": {
                        bgcolor: "rgba(255,255,255,0.06)",
                    },
                    "&.Mui-selected:hover": {
                        bgcolor: "rgba(255, 184, 1, 0.28)",
                    },
                    "&.Mui-selected:active": {
                        bgcolor: "rgba(255, 184, 1, 0.28)",
                    },
                }, children: el.label }, el.value)); }) }) }));
};
export default UISelect;
